module.exports = __webpack_public_path__ + "img/danye2.ef691261.jpg";